import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import PropTypes from "prop-types";


const PrivateRoute = ({component: Component, isAuthenticated, ...rest}) => {
  return (

    <Route {...rest} render={props => (
      isLogin(isAuthenticated) ?
        <Component {...props} />
        : <Redirect to="/vendedor" />
    )} />
  );
};

const isLogin = (isAuthenticated) => {
  return isAuthenticated;
}

PrivateRoute.propTypes = {
  component: PropTypes.object.isRequired,
  isAuthenticated: PropTypes.object.isRequired,
  rest: PropTypes.object.isRequired,
};

export default PrivateRoute;
